module.exports = __webpack_public_path__ + "static/media/Geography.64c7ad93.gif";